import { Fragment, useEffect } from 'react';
import './pricing.css';
import PricingLanding from './pricinglanding/PricingLanding';
import FlexiblePlan from './flexibleplan/FlexiblePlan';
import Plans from './plans/plans';
import BottomSec from "../Home/bottom/BottomSec";
import ComparePlans from "./ComparePlans/ComparePlans";

const Pricing = () => {
    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 500);
    },[]);
    return(
        <Fragment>
        <PricingLanding />
        {false && <FlexiblePlan />}
        <Plans />
        <ComparePlans />      
        </Fragment>
    )
}

export default Pricing;